import uniq from 'lodash/uniq';

import * as copy from 'src/templates/copy';
import {
  INVALID_IRI_MATCHER,
  IRI_STARTS_WITH_MATCHER,
} from 'src/utils/removeInvalidIriChars';

export const validateIriCharacters = (iri: string) => {
  const invalidChars = iri.match(INVALID_IRI_MATCHER);
  return invalidChars
    ? copy.components.projectDiagram.editableIri.validationIriCharacters(
        uniq(invalidChars)
      )
    : '';
};

export const validateIri = (iri: string, isBaseIri?: boolean): string => {
  if (!iri) {
    return copy.components.projectDiagram.editableIri.validationIriRequired;
  }

  if (!iri.match(IRI_STARTS_WITH_MATCHER)) {
    return copy.components.projectDiagram.editableIri.validationIriStartsWith;
  }

  if (isBaseIri) {
    if (!iri.endsWith(':')) {
      return copy.components.projectDiagram.editableIri
        .validationBaseIriSemicolon;
    }
  } else if (!iri.includes(':')) {
    return copy.components.projectDiagram.editableIri.validationIriSemicolon;
  }

  return validateIriCharacters(iri);
};

export const validatePrefix = (prefix: string): string => {
  if (prefix === '') {
    // allow empty prefixes
    return '';
  }

  if (!prefix.match(IRI_STARTS_WITH_MATCHER)) {
    return copy.components.projectDiagram.editableIri.validationIriStartsWith;
  }

  return validateIriCharacters(prefix);
};
